import type { PropsWithChildren } from 'react';

import { Text } from 'widgets';

interface Props {
    title?: string;
}

export const AuthenticationPage = ({ children, title }: PropsWithChildren<Props>) => (
    <div className="flex h-screen w-full items-start justify-center pt-[20vh]">
        <div className="flex flex-col">
            <img src="/logo-b.svg" alt="Claro Intelligent Hub Logo" />
            <div className="flex w-[400px] flex-col gap-8 pt-20 text-center">
                {title && <Text largeBody>{title}</Text>}
                {children}
            </div>
        </div>
    </div>
);
